'use client';

import { useEffect, useState, type FunctionComponent } from 'react';
import { getErrorPageContent } from '../../../_lib/sanity/actions/globals';
import { cLog } from '../../../_utils/logging/client';
import { ErrorPageContent } from './ErrorPageContent';
import type { ErrorPageContentProps, ErrorPageProps } from './types';

/**
 * Re-export this component from error.tsx files to use as the error page.
 */
export const ErrorPage: FunctionComponent<ErrorPageProps> = ({ error, reset }) => {
  const [content, setContent] = useState<ErrorPageContentProps>({
    title: 'An Error Occurred',
    cta: 'Try again',
  });

  useEffect(() => {
    async function fetchErrorPageContent() {
      try {
        const content = await getErrorPageContent('en');

        if (content?.title && content?.cta) {
          setContent(content);
        }
      } catch (e) {
        cLog?.error(
          {
            type: 'client',
            context: 'ErrorPage',
            message: 'Error fetching error page content',
            sessionId: undefined,
          },
          { error: e },
        );
      }
    }

    fetchErrorPageContent();
  }, []);

  useEffect(() => {
    cLog?.error(
      {
        type: 'client',
        context: 'ErrorPage',
        message: 'Unhandled error at page level: ',
        sessionId: undefined,
      },
      { error },
    );
  }, [error]);

  return <ErrorPageContent {...content} reset={reset} />;
};
